// src/constants/networkConfig.js
export const NETWORK_CONFIG = {
  CHAIN_ID: 1, // Ethereum Mainnet chain ID
  CHAIN_ID_HEX: '0x1', // Hexadecimal representation of 1
  CHAIN_NAME: 'Ethereum Mainnet',
  RPC_URL: 'https://eth-mainnet.g.alchemy.com/v2/0cKW-NAymPrV-FAOXKIGMK_wTTSlvjdx', // Replace with your Alchemy API endpoint for mainnet
  CURRENCY_NAME: 'Ether',
  CURRENCY_SYMBOL: 'ETH',
  CURRENCY_DECIMALS: 18,
  BLOCK_EXPLORER_URL: 'https://etherscan.io'
};


// Utility function to help users switch to the correct network
export const requestNetworkSwitch = async () => {
  if (!window.ethereum) return false;
  
  try {
    await window.ethereum.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: NETWORK_CONFIG.CHAIN_ID_HEX }],
    });
    return true;
  } catch (switchError) {
    // This error code indicates that the chain has not been added to MetaMask
    if (switchError.code === 4902) {
      try {
        await window.ethereum.request({
          method: 'wallet_addEthereumChain',
          params: [
            {
              chainId: NETWORK_CONFIG.CHAIN_ID_HEX,
              chainName: NETWORK_CONFIG.CHAIN_NAME,
              nativeCurrency: {
                name: NETWORK_CONFIG.CURRENCY_NAME,
                symbol: NETWORK_CONFIG.CURRENCY_SYMBOL,
                decimals: NETWORK_CONFIG.CURRENCY_DECIMALS
              },
              rpcUrls: [NETWORK_CONFIG.RPC_URL],
              blockExplorerUrls: [NETWORK_CONFIG.BLOCK_EXPLORER_URL]
            }
          ],
        });
        return true;
      } catch (addError) {
        console.error("Error adding the network:", addError);
        return false;
      }
    } else {
      console.error("Error switching the network:", switchError);
      return false;
    }
  }
};